import React from 'react';
import { isMock } from 'app/blocks/middleware/config';
import TopMenu from 'app/blocks/page/TopMenu/TopMenu';

function withTopMenu<P>(Component: React.ComponentType<P>): React.ComponentType<P> {
    return function (props: P) {
        return isMock() ? (
            <TopMenu {...props}>
                <Component {...props} />
            </TopMenu>
        ) : (
            <Component {...props} />
        );
    };
}

export { withTopMenu };

export default Component => withTopMenu(Component);
